<template>
  <div>
    <header class="main-header" id="main-header" name="main-header">
      <!-- Logo -->
      <router-link tag="a" to="/dashboard" class="logo">
        <!-- mini logo for sidebar mini 50x50 pixels -->
        <span class="logo-mini">
          <img src="/icon.png" width="50" height="50" style="padding:5px;" />
        </span>
        <!-- logo for regular state and mobile devices -->
        <span
          class="logo-lg"
          style="font-family:Source Sans Pro, HelveticaNeue Condensed, Arial, Sans-Serif;"
        >
          <img src="/brand-logo-horizontal.png" style="width:200px;" />
        </span>
      </router-link>
      <!-- Header Navbar: style can be found in header.less -->
      <nav class="navbar navbar-static-top">
        <!-- Sidebar toggle button-->
        <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
          <span class="sr-only">Toggle navigation</span>
        </a>
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <li class="dropdown user user-menu" v-show="isCompanies">
              <a class="dropdown-toggle" data-toggle="dropdown">
                {{$ml.get('shared.company')}} &nbsp;&nbsp;
                <i class="fa fa-angle-down"></i>
              </a>
              <ul class="dropdown-menu">
                <li class="header"></li>
                <li>
                  <div class="table-responsive">
                    <!--ŞİRKETLER LİSTELENECEK-->
                  </div>
                </li>
              </ul>
            </li>
            <li>
              <a style="display:none;">
                <i class="fa fa-comments"></i>
              </a>
            </li>
            <li>
              <a style="display:none;">
                <i class="fa fa-envelope"></i>
              </a>
            </li>
            <!--ŞİRKETLER BASLANGIC-->
            <!--<li class="dropdown messages-menu">
              <a class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-building"></i>
              </a>
              <ul class="dropdown-menu">
                <li class="header text-center">{{$ml.get('shared.languageOptions')}}</li>
                <li>
                  <ul class="menu">
                    <li v-for="lang in $ml.list" :key="lang">
                      <a>
                        {{lang}}
                        <button
                          class="btn btn-sm btn-primary pull-right"
                          @click="changeLanguage(lang)"
                        >
                          <i class="fa fa-refresh"></i>
                        </button>
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="footer">
                  <a>{{$ml.get('shared.changeLanguageInfo')}}</a>
                </li>
              </ul>
            </li>-->
            <!--ŞİRKETLER SON-->
            <li class="dropdown messages-menu">
              <a class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-bell"></i>
                <span v-show="totalNotify > 0" class="label label-warning">{{totalNotify}}</span>
              </a>
              <ul class="dropdown-menu" style="background-color:#ECF0F5;">
                <li class="header">{{$ml.get('shared.notifications')}}</li>
                <li>
                  <!-- inner menu: contains the actual data -->
                  <ul v-show="notificationList.length > 0" class="menu">
                    <li v-for="notify in notificationList" :key="notify.id">
                      <a>
                        <div v-if="notify.type == 'success'" class="pull-left yesil">
                          <i class="fa fa-check"></i>
                        </div>
                        <div v-if="notify.type == 'warning'" class="pull-left turuncu">
                          <i class="fa fa-warning"></i>
                        </div>
                        <div v-if="notify.type == 'danger'" class="pull-left kirmizi">
                          <i class="fa fa-ban"></i>
                        </div>
                        <div v-if="notify.type == 'primary'" class="pull-left mavi">
                          <i class="fa fa-info-circle"></i>
                        </div>
                        <h4>
                          {{$ml.get('shared.deviceCommunication')}}
                          <small>
                            <i class="fa fa-clock-o"></i>
                            {{notify.time}}
                          </small>
                        </h4>
                        <p>{{notify.description}}</p>
                      </a>
                    </li>
                  </ul>
                  <div v-show="notificationList.length == 0" class="text-center">
                    <span>{{$ml.get('shared.notificationNotFound')}}</span>
                  </div>
                </li>
                <li class="footer">
                  <a>{{$ml.get('shared.notificationView')}} {{totalNotify}}</a>
                </li>
              </ul>
            </li>
            <li class="dropdown user user-menu">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <img
                  :src="user.profileUrl == null || user.profileUrl == '' || user.profileUrl == 'null' ? '/src/assets/user.png' : user.profileUrl"
                  class="user-image"
                />
                <span>{{user.userName}}</span>
              </a>
              <ul class="dropdown-menu">
                <!-- User image -->
                <li class="user-header">
                  <img
                    :src="user.profileUrl == null || user.profileUrl == '' || user.profileUrl == 'null' ? '/src/assets/user.png' : user.profileUrl"
                    class="img-circle"
                  />
                  <p>
                    <span>{{user.userName}}</span>
                    <small>{{user.title}}</small>
                  </p>
                </li>
                <!-- Menu Footer-->
                <li class="user-footer">
                  <div class="d-flex justify-content-between">
                    <button
                      class="btn btn-success"
                      style="display:inline-block;"
                      @click.prevent="goToMyProfile()"
                    >
                      <i class="fa fa-user-circle"></i>
                      {{$ml.get('shared.myProfile')}}
                    </button>
                    <button
                      class="btn btn-danger pull-right"
                      style="display:inline-block;"
                      @click.prevent="logOut"
                    >
                      <i class="fa fa-sign-out"></i>
                      {{$ml.get('shared.logOut')}}
                    </button>
                  </div>
                </li>
              </ul>
            </li>
            <li>
              <a href="#" data-toggle="control-sidebar">
                <i class="fa fa-cog"></i>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>

    <!-- =============================================== -->
    <!-- Left side column. contains the sidebar -->
    <aside class="main-sidebar">
      <!-- sidebar: style can be found in sidebar.less -->
      <section class="sidebar">
        <!-- Sidebar user panel -->
        <div class="user-panel">
          <div class="pull-left image">
            <img
              :src="user.profileUrl == null || user.profileUrl == '' || user.profileUrl == 'null' ? '/src/assets/user.png' : user.profileUrl"
              class="img-circle"
            />
          </div>
          <div class="pull-left info" style="white-space: normal;">
            <p>{{user.userName}}</p>
            <span style="font-size:12px;">{{user.title}}</span>
          </div>
        </div>
        <!-- sidebar menu: : style can be found in sidebar.less -->
        <ul class="sidebar-menu" data-widget="tree">
          <li v-show="authMap.dashboard != 2">
            <router-link to="/dashboard" tag="a">
              <i class="fa fa-dashboard"></i>
              <span>{{$ml.get('shared.dashboard')}}</span>
            </router-link>
          </li>
          <li v-show="authControl(authMap.canliIzleme)">
            <router-link to="/real-time-monitor" tag="a">
              <i class="fa fa-video-camera"></i>
              <span>{{$ml.get('shared.realTimeMonitor')}}</span>
            </router-link>
          </li>
          <li v-show="authMap.kisiler != 2">
            <router-link to="/employees" tag="a">
              <i class="fa fa-users"></i>
              <span>{{$ml.get('shared.employees')}}</span>
            </router-link>
          </li>
          <li v-show="authControl(authMap.tanimlamalar)">
            <router-link to="/operations" tag="a">
              <i class="fa fa-th-large"></i>
              <span>{{$ml.get('shared.batchOperations')}}</span>
            </router-link>
          </li>
          <li class="treeview" v-show="authControl(authMap.raporlar)">
            <a href="#">
              <i class="fa fa-file-text"></i>
              <span>{{$ml.get('shared.reports')}}</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right"></i>
              </span>
            </a>
            <ul class="treeview-menu">
              <li v-show="authControl(authMap.raporlar)">
                <router-link to="/reports" tag="a">
                  <i class="fa fa-file-text"></i>
                  <span>{{$ml.get('shared.reports')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.puantajYonetimi) && modules.payrollManagement">
                <router-link to="/shift-report" tag="a">
                  <i class="fa fa-file-text"></i>
                  <span>{{$ml.get('reports.reports.ShiftReport')}}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/vertical-first-in-last-out-report" tag="a">
                  <i class="fa fa-file-text"></i>
                  <span>{{$ml.get('reports.reports.VerticalFirstInLastOutReport')}}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li v-show="authControl(authMap.puantajYonetimi) && modules.payrollManagement">
            <router-link to="/payroll-management" tag="a">
              <i class="fa fa-briefcase"></i>
              <span>{{$ml.get('shared.payrollManagement')}}</span>
            </router-link>
          </li>
          <li v-show="authControl(authMap.shiftYonetimi) && modules.shiftManagement">
            <router-link to="/shift-management" tag="a">
              <i class="fa fa-calendar"></i>
              <span>{{$ml.get('shared.shiftManagement')}}</span>
            </router-link>
          </li>
          <li class="treeview" v-show="modules.payrollManagement && authControl(authMap.puantajYonetimi)">
            <a href="#">
              <i class="fa fa-archive"></i>
              <span>{{$ml.get('shared.inventoryManagement')}}</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right"></i>
              </span>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link to="/inventories" tag="a">
                  <i class="fa fa-archive"></i>
                  <span>{{$ml.get('shared.inventories')}}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventory-categories" tag="a">
                  <i class="fa fa-archive"></i>
                  <span>{{$ml.get('shared.inventoryCategories')}}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventory-warehouses" tag="a">
                  <i class="fa fa-archive"></i>
                  <span>{{$ml.get('shared.inventoryWarehouses')}}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventory-fields" tag="a">
                  <i class="fa fa-archive"></i>
                  <span>{{$ml.get('shared.inventoryFields')}}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="treeview" v-show="authControl(authMap.ziyaretciTakip) && modules.visitor">
            <a href="#">
              <i class="fa fa-address-card"></i>
              <span>{{$ml.get('shared.visitors')}}</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right"></i>
              </span>
            </a>
            <ul class="treeview-menu">
              <li v-show="authControl(authMap.ziyaretciTakip)">
                <router-link to="/visitors" tag="a">
                  <i class="fa fa-users"></i>
                  <span>{{$ml.get('shared.visitors')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.ziyaretciTakip)">
                <router-link to="/visitor-cards" tag="a">
                  <i class="fa fa-address-card"></i>
                  <span>{{$ml.get('shared.visitorCards')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.ziyaretciTakip)">
                <router-link to="/visitor-reports" tag="a">
                  <i class="fa fa-file-text"></i>
                  <span>{{$ml.get('shared.visitorReports')}}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="treeview" v-show="authControl(authMap.kisiler) && modules.plate">
            <a href="#">
              <i class="fa fa-car"></i>
              <span>{{$ml.get('shared.licensePlateRecognition')}}</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right"></i>
              </span>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link to="/license-plate-recognition" tag="a">
                  <i class="fa fa-car"></i>
                  <span>{{$ml.get('shared.licensePlateRecognition')}}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="treeview" v-show="modules.dormitory">
            <a href="#">
              <i class="fa fa-graduation-cap"></i>
              <span>{{$ml.get('shared.studentTransactions')}}</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right"></i>
              </span>
            </a>
            <ul class="treeview-menu">
              <li v-show="modules.dormitory">
                <router-link to="/build-definitions" tag="a">
                  <i class="fa fa-building"></i>
                  <span>{{$ml.get('shared.areas')}}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li v-show="authMap.creditSale != 2 && modules.retailSale">
            <router-link to="/retail-sale" tag="a">
              <i class="fa fa-money"></i>
              <span>{{$ml.get('shared.retailSale')}}</span>
            </router-link>
          </li>
          <li class="treeview" v-show="authMap.yemekhane != 2 && modules.diningHall">
            <a href="#">
              <i class="fa fa-cutlery"></i>
              <span>{{$ml.get('shared.diningHall')}}</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right"></i>
              </span>
            </a>
            <ul class="treeview-menu">
              <li v-show="authControl(authMap.yemekhane) && modules.diningHall">
                <router-link to="/food-group-operations" tag="a">
                  <i class="fa fa-users"></i>
                  <span>{{$ml.get('shared.employeeOperations')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.yemekhane) && modules.diningHall">
                <router-link to="/food-groups" tag="a">
                  <i class="fa fa-cutlery"></i>
                  <span>{{$ml.get('shared.foodGroups')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.yemekhane) && modules.diningHall">
                <router-link to="/food-group-reports" tag="a">
                  <i class="fa fa-file-text"></i>
                  <span>{{$ml.get('shared.diningHallReports')}}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="treeview" v-show="modules.guardTour && authControl(authMap.bekciTur)">
            <a href="#">
              <i class="fa fa-shield"></i>
              <span>{{$ml.get('shared.guardTourSystem')}}</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right"></i>
              </span>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link to="/guards" tag="a">
                  <i class="fa fa-user-secret"></i>
                  <span>{{$ml.get('shared.guards')}}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/guard-tour-area" tag="a">
                  <i class="fa fa-building"></i>
                  <span>{{$ml.get('shared.areas')}}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/control-points" tag="a">
                  <i class="fa fa-thumb-tack"></i>
                  <span>{{$ml.get('shared.points')}}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/guard-tours" tag="a">
                  <i class="fa fa-flag-checkered"></i>
                  <span>{{$ml.get('shared.tours')}}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/guard-tour-reports" tag="a">
                  <i class="fa fa-file-text"></i>
                  <span>Tur Hareket Raporu</span>
                </router-link>
              </li>
              <li>
                <router-link to="/guard-tour-incident-reports" tag="a">
                  <i class="fa fa-file-text"></i>
                  <span>Tur Olay Raporları</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li
            class="treeview"
            id="m_tanimlamalar"
            v-show="authMap.tanimlamalar != 2 && authMap.gecisYetkileri != 2"
          >
            <a href="#">
              <i class="fa fa-book"></i>
              <span>{{$ml.get('shared.definitions')}}</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right"></i>
              </span>
            </a>
            <ul class="treeview-menu">
              <li v-show="authControl(authMap.tanimlamalar)">
                <router-link to="/card-designs" tag="a">
                  <i class="fa fa-id-card-o"></i>
                  <span>{{$ml.get('shared.cardDesignTemplates')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.tanimlamalar)">
                <router-link to="/extra-fields" tag="a">
                  <i class="fa fa-users"></i>
                  <span>{{$ml.get('shared.extraFields')}}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/document-definitions" tag="a">
                  <i class="fa fa-file-text"></i>
                  <span>{{$ml.get('shared.documentDefinitions')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.tanimlamalar)">
                <router-link to="/departments" tag="a">
                  <i class="fa fa-sitemap"></i>
                  <span>{{$ml.get('shared.departments')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.tanimlamalar)">
                <router-link to="/access-groups" tag="a">
                  <i class="fa fa-key"></i>
                  <span>{{$ml.get('shared.accessGroups')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.tanimlamalar)">
                <router-link to="/shifts" tag="a">
                  <i class="fa fa-briefcase"></i>
                  <span>{{$ml.get('shared.workPlans')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.tanimlamalar) && modules.payroll">
                <router-link to="/overtime-settings" tag="a">
                  <i class="fa fa-clock-o"></i>
                  <span>{{$ml.get('shared.overtimeDefinitions')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.tanimlamalar)">
                <router-link to="/allowences" tag="a">
                  <i class="fa fa-plane"></i>
                  <span>{{$ml.get('shared.allowences')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.tanimlamalar)">
                <router-link to="/work-place-definitions" tag="a">
                  <i class="fa fa-building"></i>
                  <span>{{$ml.get('shared.workPlaceDefinitions')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.tanimlamalar) && modules.annualPermit">
                <router-link to="/annual-permits" tag="a">
                  <i class="fa fa-plane"></i>
                  <span>{{$ml.get('shared.annualPermitGroups')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.tanimlamalar) && modules.scenario">
                <router-link to="/scenario-list" tag="a">
                  <i class="fa fa-bookmark"></i>
                  <span>{{$ml.get('shared.scenarioList')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.tanimlamalar) && modules.timezone">
                <router-link to="/timezones" tag="a">
                  <i class="fa fa-exchange"></i>
                  <span>{{$ml.get('shared.timeZones')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.tanimlamalar)">
                <router-link to="/devices" tag="a">
                  <i class="fa fa-microchip"></i>
                  <span>{{$ml.get('shared.devices')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.tanimlamalar)">
                <router-link to="/device-operations" tag="a">
                  <i class="fa fa-random"></i>
                  <span>{{$ml.get('shared.deviceOperations')}}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="treeview" id="m_ayarlar">
            <a href="#">
              <i class="fa fa-cogs"></i>
              <span>{{$ml.get('shared.settings')}}</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right"></i>
              </span>
            </a>
            <ul class="treeview-menu">
              <li v-show="authControl(authMap.ayarlar)">
                <router-link to="/company-settings" tag="a">
                  <i class="fa fa-wrench"></i>
                  <span>{{$ml.get('shared.companySettings')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.ayarlar) && authControl(authMap.shiftYonetimi) && modules.shiftManagement">
                <router-link to="/shift-settings" tag="a">
                  <i class="fa fa-calendar"></i>
                  <span>{{$ml.get('shared.shiftSettings')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.ayarlar)">
                <router-link to="/users" tag="a">
                  <i class="fa fa-user-circle"></i>
                  <span>{{$ml.get('shared.users')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.ayarlar)">
                <router-link to="/user-authority-groups" tag="a">
                  <i class="fa fa-address-card"></i>
                  <span>{{$ml.get('shared.userAuthorityGroups')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.ayarlar) && modules.smsOrMail">
                <router-link to="/mail-sms-settings" tag="a">
                  <i class="fa fa-envelope"></i>
                  <span>{{$ml.get('shared.mailSmsSettings')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.ayarlar)">
                <router-link to="/user-logs" tag="a">
                  <i class="fa fa-tasks"></i>
                  <span>{{$ml.get('shared.userLogs')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.ayarlar) && modules.payroll">
                <router-link to="/payroll-types" tag="a">
                  <i class="fa fa-map-signs"></i>
                  <span>{{$ml.get('shared.payrollTypes')}}</span>
                </router-link>
              </li>
              <li v-show="authControl(authMap.ayarlar) && modules.payroll">
                <router-link to="/monthly-payroll-tables" tag="a">
                  <i class="fa fa-calendar"></i>
                  <span>{{$ml.get('shared.monthlyPayrollTables')}}</span>
                </router-link>
              </li>
              <!--<li>
                <router-link to="/app-settings" tag="a">
                  <i class="fa fa-sliders"></i>
                  <span>Uygulama Ayarları</span>
                </router-link>
              </li>-->
              <li v-show="authControl(authMap.ayarlar) && modules.integration">
                <router-link to="/integration" tag="a">
                  <i class="fa fa-code-fork"></i>
                  <span>{{$ml.get('shared.integration')}}</span>
                </router-link>
              </li>
              <!--<li>
                <router-link to="/help" tag="a">
                  <i class="fa fa-life-ring"></i>
                  <span>{{$ml.get('shared.support')}}</span>
                </router-link>
              </li>-->
              <li>
                <router-link to="/app-about" tag="a">
                  <i class="fa fa-info-circle"></i>
                  <span>{{$ml.get('shared.appAbout')}}</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </section>
      <!-- /.sidebar -->
    </aside>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  HubConnectionBuilder,
  LogLevel,
  HubConnection
} from "@microsoft/signalr";
export default {
  data() {
    return {
      user: {
        userName: "",
        title: "",
        profileUrl: null
      },
      authMap: {
        canliIzleme: 2,
        kisiler: 2,
        gecisYetkileri: 2,
        raporlar: 2,
        ayarlar: 2,
        tanimlamalar: 2,
        ziyaretciTakip: 2,
        yemekhane: 2,
        creditSale: 2,
        dashboard: 2,
        shiftYonetimi: 2,
        puantajYonetimi: 2,
        shiftYetkileri: {
          canPlan: true,
          canConfirmShift: true,
          canConfirmAllowence: true,
          canPlanAllowence: true,
          canSeeRealMovements: false,
          sendMailWhenUnconfirmedShifts: false,
          sendWarningMailOnSecondDay: false
        }
      },
      defaultLanguage: "",
      totalNotify: 0,
      notifications: [],
      isCompanies: false
    };
  },
  filters: {
    toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    modules() {
      return this.$store.getters.getModules;
    },
    notificationList() {
      return this.notifications;
    },
    baseURL() {
      return this.$store.getters.getBaseURL;
    },
    activeUser() {
      return this.$store.getters.getUser;
    }
  },
  mounted() {
    var hubConnection = new HubConnectionBuilder()
      .withUrl(this.baseURL + "/notifyhub")
      .withAutomaticReconnect()
      .build();
    // connecting to the hub
    hubConnection
      .start()
      .then(() => {
        console.log("connection started");
        this.connection = true;
      })
      .catch(err => {
        console.log("connecting hub failed err is : ", err);
        this.connection = false;
      });

    hubConnection.on("serviceNotify", result => {
      if (result.userId == this.activeUser.id) {
        alertify.success(result.message);
      }
    });

    hubConnection.onclose(() => {
      console.log("connection failed");
      this.connection = false;
    });
  },
  methods: {
    authControl(data) {
      if (data != null) {
        if (data == 2) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    changeLanguage(lang) {
      this.$ml.change(lang);
      this.defaultLanguage = lang;
      localStorage.setItem("lang", this.defaultLanguage);
    },
    async getCompanySettings() {
      try {
        this.isLoading = true;
        var requiredFields = [];
        const response = await this.$axios
          .get("/CompanySettings/1")
          .then(response => {
            if (response.status == 200) {
              requiredFields = response.data.requiredFields;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        await this.$store.commit("setRequiredFields", requiredFields);
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata : " + error.message);
        this.isLoading = false;
      }
    },
    async getAuthority() {
      try {
        this.isLoading = true;
        var authMap = {};
        const response = await this.$axios
          .get("/User/GetAuthMap")
          .then(response => {
            if (response.status == 200) {
              authMap.canliIzleme = response.data.canliIzleme;
              authMap.kisiler = response.data.kisiler;
              authMap.gecisYetkileri = response.data.gecisYetkileri;
              authMap.raporlar = response.data.raporlar;
              authMap.ayarlar = response.data.ayarlar;
              authMap.tanimlamalar = response.data.tanimlamalar;
              authMap.ziyaretciTakip = response.data.ziyaretciTakip;
              authMap.yemekhane = response.data.yemekhane;
              authMap.dashboard = response.data.dashboard;
              authMap.creditSale = response.data.creditSale;
              authMap.shiftYonetimi = response.data.shiftYonetimi;
              authMap.puantajYonetimi = response.data.puantajYonetimi;
              authMap.shiftYetkileri = response.data.shiftYetkileri;
              authMap.bekciTur = response.data.bekciTur;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.authMap = authMap;
        await this.$store.commit("setAuthority", authMap);
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata : " + error.message);
        this.isLoading = false;
      }
    },
    async getNotifications() {
      try {
        this.isLoading = true;
        const notifications2 = [];
        const response = await this.$axios
          .get("/Notifications")
          .then(response => {
            response.data.forEach(doc => {
              notifications2.push({
                id: doc.id,
                type: doc.type,
                time: doc.time,
                description: doc.description
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.notifications = notifications2;
        this.totalNotify = notifications2.length;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    logOut() {
      this.$store.dispatch("logout");
    },
    goToMyProfile() {
      this.$router.replace("/my-profile");
    }
  },
  async created() {
    await this.getAuthority();
    await this.getCompanySettings();
    this.user = this.$store.getters.getUser;
    await this.getNotifications();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/shared/Header.vue